/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const AbstractItemCommand = require('./AbstractItemCommand');
const Expression = require('../expr/Expression');

/**
 * @class SetChartFormulaCommand
 * @type {module.SetChartFormulaCommand}
 */
module.exports = class SetChartFormulaCommand extends AbstractItemCommand {
	constructor(item, selection, expression) {
		super(item);

		this.element = selection.element;
		this.index = selection.index;
		this.expression = expression;
	}

	undo() {
	}

	redo() {
		switch (this.element) {
		case 'series':
			if (this._graphItem.series[this.index].formula && this.expression.getFormula() !== this._graphItem.series[this.index].formula.getFormula()) {
				this._graphItem.series[this.index].formula = this.expression;
				this._graphItem.chart.formula = new Expression('');
				this._graphItem.chart.coharentData = false;
			}
			break;
		case 'title':
			this._graphItem.title.formula = this.expression;
			break;
		case 'xAxis':
			this._graphItem.xAxes[this.index].formula = this.expression;
			break;
		case 'xAxisTitle':
			this._graphItem.xAxes[this.index].title.formula = this.expression;
			break;
		case 'yAxis':
			this._graphItem.yAxes[this.index].formula = this.expression;
			break;
		case 'yAxisTitle':
			this._graphItem.yAxes[this.index].title.formula = this.expression;
			break;
		case 'legend':
			this._graphItem.legend.formulaTitle = this.expression;
			break;
		case 'plot':
			this._graphItem.chart.formula = this.expression;
			this._graphItem.chart.coharentData = true;
			break;
		default:
			break;
		}

		this._graphItem.evaluate();
		this._graphItem.getGraph().markDirty();
	}

	doAfterRedo() {}

	doAfterUndo() {}
};
